import * as React from 'react';
import styled from 'styled-components';
import {BlockTitle} from '../components/styled';
import {transition} from 'helpers/css';
import {CoursePromoContext} from '../context';
import {CourseGiftItem} from '../types';

const Container = styled.div`
  padding: 48px 60px 60px;
  border-radius: 10px;
  background: ${({theme}) => theme.colors.primary};
  
  @media screen and (max-width: 640px) {
    margin: 0 auto;
    padding: 40px 16px;
  }
`;

const Title = styled(BlockTitle)`
  margin-bottom: 30px;
`;

const GiftsList = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;

  @media screen and (max-width: 1160px) {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
  }
`;

const GiftItem = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 13px;
  border-radius: 10px;
  background: ${({theme}) => theme.colors.primaryLight};
  border: 1px solid ${({theme}) => theme.colors.primary};
  cursor: pointer;
  ${transition()}

  &:hover {
    border: 1px outset ${({theme}) => theme.colors.primaryLight};
    background: ${({theme}) => theme.colors.primary};
  }

  @media screen and (max-width: 640px) {
    padding: 4px;
  }
`;

const GiftCover = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 21px;
  
  height: 88px;
  min-height: 62px;
  
  min-width: 110px;
  width: 100%;
  max-width: 160px;
  
  border-radius: 10px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media screen and (max-width: 640px) {
    height: 62px;
    width: 110px;
  }
`;

const GiftTitle = styled.div`
  font-size: 22px;
  font-weight: 600;
  line-height: 29px;

  @media screen and (max-width: 640px) {
    font-size: 14px;
    line-height: 18px;
  }
`;

/**
 * The returns course gifts component
 * @return {React.ReactElement}
 * @constructor
 */
export default function FreeCourses(): React.ReactElement {
  const context = React.useContext(CoursePromoContext);

  /**
   * Render gift courses
   * @return {React.ReactNodeArray}
   * @constructor
   */
  function renderContent(): React.ReactNodeArray {
    return context
        .giftCourses
        .items
        .map(renderItems);
  }

  /**
   * Render course gifts items
   * @param {GiftItem} item
   * @param {number} ind
   * @return {React.ReactElement | null}
   * @constructor
   */
  function renderItems(item: CourseGiftItem, ind: number) {
    return (
      <GiftItem key={item.toString() + ind}>
        <GiftCover>
          <img src={item.cover} alt="обложка"/>
        </GiftCover>
        <GiftTitle>
          {item.title}
        </GiftTitle>
      </GiftItem>
    );
  }

  return (
    <Container>
      <Title>{context.giftCourses.label || 'Курсы в подарок!'}</Title>
      <GiftsList>
        {renderContent()}
      </GiftsList>
    </Container>
  );
}
